export function assertDefined<T>(
    val: T | undefined | null,
    msg?: string
): asserts val is T {
    if (val === undefined || val === null) {
        throw new Error(msg ?? `val can't be undefined or null`);
    }
}

function isValidationErrorResponse(
    error: any
): error is ValidationErrorResponse {
    return (error as ValidationErrorResponse).violations !== undefined;
}

function isErrorResponse(error: any): error is ErrorResponse[] {
    return Array.isArray(error) && error.length > 0 && error[0].errorMessage;
}

function extractMessageWithArguments(
    message: any
): string | undefined {
    if (message?.defaultMessage) return message.defaultMessage;
    const args = message?.arguments;
    if (Array.isArray(args) && args.length > 0 && typeof args[0] === 'string') {
        return args[0];
    }
    return undefined;
}

export function subtractErrorMessage(error: any): string | undefined {
    error = error.error || error;
    if (isErrorResponse(error)) {
        return extractMessageWithArguments(error[0].message)
            || error[0].defaultMessage;
    } else if (isValidationErrorResponse(error) && error.violations) {
        return error.violations
            .map((violation) => {
                return extractMessageWithArguments(violation.message)
                    || violation.message?.defaultMessage;
            })
            .filter((m) => Boolean(m))
            .join('<br>');
    } else if (error.message) {
        const fromMessage = extractMessageWithArguments(error.message);
        if (fromMessage) return fromMessage;
        if (typeof error.message === 'string') return error.message;
    } else if (error.defaultMessage) {
        return error.defaultMessage;
    }
    return undefined;
}
